import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { Form } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import BuildTab from '../BuildSheet/BuildTab';
import { Link, useParams } from "react-router-dom";
import { addPrescription, getPrescription, upatePrescription, upatePrescriptionStatus, upatedeliverytype } from "../../Api/prescriptionApis";
import Spinner from 'react-bootstrap/Spinner';
import { MdBookmarkAdd } from "react-icons/md";
import { getCurrentUser } from "../../Api/auth";
import { IoCloseSharp } from "react-icons/io5";
import { useHistory } from 'react-router-dom';
import { getbuildsheet, addbuildsheetapi } from "../../Api/buildsheetApi"
import Modal from 'react-bootstrap/Modal';
import { FaStar } from "react-icons/fa";
import PrescriptionLeft from './PrescriptionLeft';
import BuildTabPrescription from '../BuildSheet/BuildTabPrescription';
import Loader2 from '../DashboardComponents/Loader/Loader2';
import { getremoteInquirydataApi } from "../../Api/iron"
import { getallModeldatabymake } from "../../Api/inventoryApi";
import { getsingleprescription } from "../../Api/iron"
import { getInventoryByType } from "../../Api/inventoryApi";
import BuildTab4 from '../BuildSheet/BuildTab4';
import LeftScript3 from './LeftScript3';
import LeftScript4 from './LeftScript4';
import PrescTab2 from '../BuildSheet/PrescTab2';
import Simplemsg from '../../Components/CustomeModel/Simplemsg';

const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};

const initialNewPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',

    bouncedropdownselect: '',
    lieagedropdownselect: '',
    shaftweightdropdownselect: '',
    shaftflexdropdownselect: '',
    shaftprofiledropdownselect: '',
    gripSizedropdownselect: '',
    clubLengthdropdownselect: '',
    swingWeightdropdownselect: '',
};


function Prescription() {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };


    const [isLoading, setIsLoading] = useState(false);
    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);
    const params = useParams();

    const [validated, setValidated] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [errors, setErrors] = useState([]);

    const [prescription, setPrescription] = useState(initialPrescriptionState);
    const [apicall, setApicall] = useState(false);
    const [prescriptionid, setPrescriptionid] = useState(null);
    const [selectedOption2, setSelectedOption2] = useState('Prescribed');
    const [selectedOption3, setSelectedOption3] = useState('Delivery');
    const [selectedOption3id, setSelectedOption3id] = useState(0);
    const [apicallupate, setApicallUpate] = useState(false);
    const [status, setStatus] = useState('');
    const [userdata, setUserdata] = useState('');
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [apicallNew, setapicallNew] = useState(false);

    const [isOpen2, setIsOpen2] = useState(false);

    const [isOpen3, setIsOpen3] = useState(false);

    const [studioshow, setstudioShow] = useState(false);

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const toggleDropdown3 = () => {
        setIsOpen3(!isOpen3);
    };

    const closeDropdown2 = () => {
        setIsOpen2(false);
    };

    const selectOption2 = (option) => {
        setSelectedOption2(option);
    };

    const selectOption3 = (option) => {
        setSelectedOption3(option.text);
        setSelectedOption3id(option.id);

    };

    const options2 = [
        { text: 'Prescribed', },
        { text: 'Contacted', },
        { text: 'Reviewed', },
        { text: 'Invoiced', },
        { text: 'Purchased', }
    ];

    const options3 = [
        { text: 'Pick up', id: 1 },
        { text: 'Shipping', id: 2 },
    ];

    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const [modelmessage, setModelmessage] = useState('');


    const handleupateprojectstatus = () => {
        setApicallUpate(true);
        const status = (selectedOption2).charAt(0).toLowerCase() + (selectedOption2).slice(1);
        if (status === 'purchased') {
            const fittingData = { optimalHeads, optimalShafts, optimalGrips, fiterdata, optimalHeadsobject, optimalShaftsobject, optimalGripsobject };

            const result = checkFittingData(fittingData);
            // Check if any required data is missing
            const missingData = Object.entries(result)
                .filter(([key, value]) => !value)
                .map(([key]) => key);

            if (missingData.length > 0) {
                handleOpenModal()
                setModelmessage(`The following fields are missing data: ${missingData.join(', ')}`)
                // alert();
                setApicallUpate(false); // Stop further API call since data is missing
                return;
            }
        }
        const data = {
            'status': (selectedOption2).charAt(0).toLowerCase() + (selectedOption2).slice(1),
            'id': prescriptionid,
            'project_id': params.id,
            'user_id': userdata._id,
            'fitter_name': userdata.firstname + " " + userdata.lastname,
        }
        upatePrescriptionStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                //getprojectdata();
                closeDropdown2();
                if (selectedOption2 === "Purchased") {
                    window.location.reload();
                }
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }


    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }
        getDataById();
        getprojectdata();
        getRemortFittingDataById();
        getallModels();
        getprescriptionDataById();
        getallmakedata(0);
        window.scrollTo(0, 0);
    }, []);

    const getDataById = () => {
        setIsLoading(true);
        getbuildsheet({ id: params.id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetNumber(Data._id);
            } else {
                // alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const addbuildsheet = () => {
        setapicallNew(true);
        const data = {
            'project_id': params.id,
            'user_id': userdata._id,
            'fitter_name': userdata.firstname + " " + userdata.lastname,
            "type_id": 1,
            "builsheetnumber": "Driver"
        }
        addbuildsheetapi(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                // setErrors(res.data.data);
                //  alert(res.data.data[0].detail);
            } else {
                setapicallNew(false);
                //  setPrescription(res.data.data);
                window.location.href = `/project/buildsheet/buildsheet-view/${params.id}`;
            }
        }).catch((err) => {
            alert(err);
        });
    }

    const getprojectdata = () => {
        //  setApicall(true);
        setIsLoading(true);
        getPrescription({ project_id: params.id }).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                // setErrors(res.data.data);
                //  alert(res.data.data[0].detail);
            } else {
                //     setApicall(false);
                //  setPrescription(res.data.data);
                setPrescriptionid(res.data.data._id);
                const status = res.data.data.status;
                const upercasestatus = (status).charAt(0).toUpperCase() + (status).slice(1);
                setSelectedOption2(upercasestatus);
                setStatus(status);
                setPrescription(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const [remortFittingFormData, setRemortFittingFormData] = useState(initData);

    const [fiterdata, setfiiterdata] = useState(initialNewPrescriptionState);

    const [optimalHeadsobject, setOptimalHeadsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalShaftsobject, setOptimalShaftsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalGripsobject, setOptimalGripsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: params.id }).then((res) => {
            if (res?.code === 200) {
                const userData = res.data.data;
                setRemortFittingFormData(userData);
                setfiiterdata(userData?.fittingdata);
                setOptimalHeads(userData?.optimalHeadsStar);
                setOptimalGrips(userData?.optimalGripsStar);
                setOptimalShafts(userData?.optimalShaftsStar);

                setOptimalHeadsobject(userData?.optimalHeads);
                setOptimalShaftsobject(userData?.optimalShafts);
                setOptimalGripsobject(userData?.optimalGrips);
                // setstudioShow(userData.studio_fitting === 0 ? false : true);
                setstudioShow(!!userData.studio_fitting);

                setSelectedOption3(res.data.data?.delivery_type ? res.data.data?.delivery_type === 1 ? "Pick up" : "Shipping" : "Delivery");
                setSelectedOption3id(res.data.data?.delivery_type);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
    }, [remortFittingFormData]);

    const [allmodels, setAllModels] = useState([]);

    const getallModels = () => {
        getallModeldatabymake().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setAllModels(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [SinglePrescription, setSinglePrescription] = useState(0);

    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: params.id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setSinglePrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }


    const [allMakeData, setallMakeData] = useState([]);

    const getallmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setallMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [apiCall, setApiCall] = useState(0);


    useEffect(() => {
        if (apiCall) {
            getprojectdata();
        }
    }, [apiCall]);

    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);

    const updateoptimaldata = (data, type) => {
        console.log("updateoptimaldata", data, type);
        if (type === "optimalHeads") {
            setOptimalHeadsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...data // Update with new data
            }));
        }

        if (type === "optimalShafts") {
            setOptimalShaftsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...data // Update with new data
            }));
        }

        if (type === "optimalGrips") {
            setOptimalGripsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...data // Update with new data
            }));
        }
    }




    const setOptmalValues = (type, value) => {
        console.log("setOptmalValues", type, value);
        if (type === 'optimalHeads') {
            setOptimalHeads(value);
        }
        if (type === 'optimalShafts') {
            setOptimalShafts(value);
        }
        if (type === 'optimalGrips') {
            setOptimalGrips(value);
        }
    }

    const checkFittingData = (fittingData) => {
        const {
            optimalHeads,
            optimalShafts,
            optimalGrips,
            fiterdata,
            optimalHeadsobject,
            optimalShaftsobject,
            optimalGripsobject
        } = fittingData;

        // const isEmptyObject = (obj) => obj && Object.values(obj).every(value =>
        //     typeof value === 'object' ? isEmptyObject(value) : value === '');

        const hasData = {
            optimalHeads: optimalHeads > 0,
            optimalShafts: optimalShafts > 0,
            optimalGrips: optimalGrips > 0,
            fiterdata: Object.values(fiterdata).some(value => value !== ''),
            optimalHeadsobject: optimalHeadsobject?.option1?.model !== "" && optimalHeadsobject?.option2?.model && optimalHeadsobject?.option3?.model,
            optimalShaftsobject: optimalShaftsobject?.option1?.model !== "" && optimalShaftsobject?.option2?.model && optimalShaftsobject?.option3?.model,
            optimalGripsobject: optimalGripsobject?.option1?.model !== "" && optimalGripsobject?.option2?.model && optimalGripsobject?.option3?.model,
        };

        return hasData;
    };

    // const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleupatedelivery = () => {
        setApicallUpate(true);
        const data = {
            'delivery_type': selectedOption3id,
            'prescriptionid': prescriptionid,
            'project_id': params.id,
            'user_id': userdata._id,
            'fitter_name': userdata.firstname + " " + userdata.lastname,
        }
        upatedeliverytype(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                toggleDropdown3();
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }


    return (
        <>
            {
                remortFittingFormData.firstname != "" ? (
                    <>
                        {
                            isLoading ? (
                                <div className="loading">
                                    <Loader2 />
                                </div>
                            ) : (
                                <>
                                    <Modal
                                        show={show03}
                                        // onHide={handleClose03}
                                        onHide={() => {
                                            handleClose03();
                                            window.scrollTo(0, 0);

                                        }}
                                        centered
                                        id="success_tic"
                                        className='model-thank-you'
                                    >
                                        <Modal.Body>
                                            <h2 className="text-center mb-3">
                                                Success!
                                            </h2>
                                            <p className="text-center mb-4">
                                                Your data added successfully.
                                            </p>

                                            <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                                                OK, got it!
                                            </button>
                                        </Modal.Body>
                                    </Modal>

                                    <Simplemsg
                                        show={showModal}
                                        onClose={handleCloseModal}
                                        title="Warning!"
                                        message={modelmessage}
                                        buttonText="Close"
                                    />


                                    <div className="main-page-body-content-header">
                                        <HeaderAdmin />
                                    </div>
                                    <div className='design_show_mobile'>
                                        <div className='fixed-btn'>
                                            {/* {
                                                status === "purchased" ? (
                                                    <Link to={`/create-buildsheet?id=${params.id}`}>
                                                        
                                                ) : (
                                                    ""
                                                )
                                            } */}

                                            {
                                                status === "purchased" && selectedOption3id !== 0 && (optimalGrips > 0 && optimalShafts > 0 && optimalHeads > 0) ? (
                                                    <>
                                                        {buildsheetnumber !== undefined && buildsheetnumber !== null ? (
                                                            // "View Build Sheet" button
                                                            <button className="">
                                                                <Link to={`/project/buildsheet/buildsheet-view/${params.id}`}>
                                                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#262a31"><path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" /><path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" /><path clip-rule="evenodd" d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z" fill-rule="evenodd" /></g></svg>
                                                                </Link>
                                                            </button>
                                                        ) : (
                                                            // "Create Build Sheet" button
                                                            <button className=" " onClick={addbuildsheet}>
                                                                {
                                                                    apicallNew === true ? (<Spinner animation="border" className="border-black" />) : <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#262a31"><path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" /><path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" /><path clip-rule="evenodd" d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z" fill-rule="evenodd" /></g></svg>
                                                                }
                                                            </button>
                                                        )}
                                                    </>
                                                ) : (
                                                    <button disabled>
                                                        <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#262a31"><path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" /><path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" /><path clip-rule="evenodd" d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z" fill-rule="evenodd" /></g></svg>
                                                    </button>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard side-marginfix" >
                                        <div className="main-container">
                                            <div className="main-page-body-content">
                                                <div className="main-page-body-content-body">
                                                    <div className="main-page-body-content-body-container">
                                                        <div className="container-fluid">
                                                            <div className="sec-header-new">
                                                                <button type="button" className="btn-header-transparent">
                                                                    <div className="border_box_view">
                                                                        <div className="border_box_view_inner">
                                                                            <div className="box_icon">
                                                                                <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
                                                                            </div>
                                                                            <div className="box_text_content">
                                                                                <div className="big_text">Prescription</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>

                                                                <div className="header-left">
                                                                    <Link to={`/project/project-view/${params.id}`}>
                                                                        <button type="button" className="btn-header-transparent me-3">
                                                                            <div className="border_box_view">
                                                                                <div className="border_box_view_inner">
                                                                                    <div className="box_icon">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" height="512" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" width="512"><g id="Icon" fill='#99ea24'><path d="m15.479 22.75h-11.479c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-16c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237v4.151c-.687-.101-1.386-.084-2.068.05-.575.112-1.055.505-1.28 1.046l-.17.41c-.224-.029-.441-.057-.441-.057-.581-.076-1.161.143-1.546.585-.521.598-.922 1.291-1.179 2.042-.19.554-.09 1.166.266 1.631l.271.353c-.137.179-.271.353-.271.353-.356.465-.456 1.077-.266 1.631.257.751.658 1.444 1.179 2.042.385.442.965.661 1.546.585l.441-.057c.086.208.17.41.17.41.023.055.049.109.077.161zm-9.979-8h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75zm7-11.75v3.5c0 .552.448 1 1 1h3.5zm-7 8.25h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8c-.414 0-.75.336-.75.75s.336.75.75.75zm0 7h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75z" /><path d="m19.396 13.044s.355.855.354.855c.135.068.266.144.393.226l.918-.12c.248-.032.497.062.662.251.436.5.771 1.081.987 1.709.081.237.038.5-.115.699 0 0-.562.735-.562.734.008.151.008.303 0 .453l.562.735c.153.199.196.462.115.699-.216.628-.551 1.209-.987 1.709-.165.189-.414.283-.662.251 0 0-.918-.12-.917-.121-.127.083-.259.159-.393.227l-.355.855c-.096.232-.302.4-.548.448-.652.128-1.322.128-1.974 0-.246-.048-.452-.216-.548-.448 0 0-.355-.855-.354-.855-.135-.068-.267-.144-.393-.226l-.918.12c-.249.032-.497-.062-.662-.251-.437-.5-.772-1.081-.987-1.709-.081-.237-.038-.5.114-.699 0 0 .563-.735.563-.734-.008-.151-.008-.303 0-.453l-.563-.735c-.152-.199-.195-.462-.114-.699.215-.628.55-1.209.987-1.709.165-.189.413-.283.662-.251 0 0 .918.12.917.121.127-.083.258-.159.393-.227l.355-.855c.096-.232.302-.4.548-.448.652-.128 1.322-.128 1.974 0 .246.048.452.216.548.448zm-1.535 3.081c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z" /></g></svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </button>
                                                                    </Link>
                                                                    <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                                        <div className="border_box_view">
                                                                            <div className="border_box_view_inner">
                                                                                <div className="box_icon">
                                                                                    <IoCloseSharp />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="dashboard-sec">
                                                                <div className="row">
                                                                    {/* <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col">
                                                                        <div className='design_hide_mobile'>
                                                                            <PrescriptionLeft project_id={params.id} disablestatus={buildsheetnumber} prescriptiondata={prescription} allmodels={allmodels} allMakeData={allMakeData} ongetChange={(number) => setApiCall(number)}/>
                                                                        </div>
                                                                    </div> */}
                                                                    <div className="">
                                                                        <div className='design_hide_mobile'>
                                                                            <LeftScript4 status={status} project_id={params.id} allMakeData={allMakeData} remortFittingFormData={remortFittingFormData} setRemortFittingFormData={setRemortFittingFormData} studioshow={studioshow} />
                                                                        </div>
                                                                    </div>
                                                                    <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                                        <div className="fix_sec_view container-fluid ps-0">
                                                                            <div className="btn-box-section mt-0 design_hide_mobile">
                                                                                {
                                                                                    status === "purchased" && selectedOption3id !== 0 && (optimalGrips > 0 && optimalShafts > 0 && optimalHeads > 0) ? (
                                                                                        <>
                                                                                            {buildsheetnumber !== undefined && buildsheetnumber !== null ? (
                                                                                                // "View Build Sheet" button
                                                                                                <button className="btn btn-primary btn-create">
                                                                                                    <Link to={`/project/buildsheet/buildsheet-view/${params.id}`}>
                                                                                                        View Build Sheet
                                                                                                    </Link>
                                                                                                </button>
                                                                                            ) : (
                                                                                                // "Create Build Sheet" button
                                                                                                <button className="btn btn-primary btn-create" onClick={addbuildsheet}>
                                                                                                    {
                                                                                                        apicallNew === true ? (<Spinner animation="border" className="border-black" />) : "Create Build Sheet"
                                                                                                    }
                                                                                                </button>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <button className="btn btn-primary btn-create" disabled>
                                                                                            Create Build Sheet
                                                                                        </button>
                                                                                    )
                                                                                }

                                                                            </div>
                                                                            <div className='select-dropdown-build'>
                                                                                <div className={`select-options-dropdown ${isOpen3 ? 'open' : ''}`}>
                                                                                    <div className='select-option-inner' onClick={selectedOption3id !== 0 ? null : toggleDropdown3}>
                                                                                        <div className='selected-option-text'>{selectedOption3}</div>
                                                                                        <span className={`icon ${isOpen3 ? 'up' : 'down'}`}>
                                                                                            <i className="bi bi-chevron-down" />
                                                                                        </span>
                                                                                    </div>

                                                                                    {isOpen3 && (
                                                                                        <div className='option-list buildsheet-option-list'>
                                                                                            <div className='drop-down-list'>
                                                                                                {options3.map(option => (
                                                                                                    <div
                                                                                                        key={option.text}
                                                                                                        className={`drop-down-item ${selectedOption3 === option.text ? 'active' : ''}`}
                                                                                                        onClick={() => selectOption3(option)}
                                                                                                    >
                                                                                                        <div className='drop-down-item-text'>{option.text}</div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                            <div className='form-box-section'>
                                                                                                {/* {
                                                                                                    selectedOption3 === "Prescribed" ? (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            disabled
                                                                                                        >
                                                                                                            <span>Update Status</span>
                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            onClick={() => {
                                                                                                                handleupatedelivery();
                                                                                                            }}
                                                                                                        >

                                                                                                            {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                        </button>
                                                                                                    )
                                                                                                } */}
                                                                                                <button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    onClick={() => {
                                                                                                        handleupatedelivery();
                                                                                                    }}
                                                                                                >

                                                                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                </button>

                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className='select-dropdown-build'>
                                                                                <div className={`select-options-dropdown ${isOpen2 ? 'open' : ''}`}>
                                                                                    <div className='select-option-inner' onClick={status === 'purchased' ? null : toggleDropdown2} >
                                                                                        <div className='selected-option-text'>{selectedOption2}</div>
                                                                                        <span className={`icon ${isOpen2 ? 'up' : 'down'}`}>
                                                                                            <i className="bi bi-chevron-down" />
                                                                                        </span>
                                                                                    </div>

                                                                                    {isOpen2 && (
                                                                                        <div className='option-list buildsheet-option-list'>
                                                                                            <div className='drop-down-list'>
                                                                                                {options2.map(option => (
                                                                                                    <div
                                                                                                        key={option.text}
                                                                                                        className={`drop-down-item ${selectedOption2 === option.text ? 'active' : ''}`}
                                                                                                        onClick={() => selectOption2(option.text)}
                                                                                                    >
                                                                                                        <div className='drop-down-item-text'>{option.text}</div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                            <div className='form-box-section'>
                                                                                                {
                                                                                                    selectedOption2 === "Prescribed" ? (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            disabled
                                                                                                        >
                                                                                                            <span>Update Status</span>
                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            onClick={() => {
                                                                                                                handleupateprojectstatus();
                                                                                                            }}
                                                                                                        >

                                                                                                            {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                        </button>
                                                                                                    )
                                                                                                }

                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className='design_hide_mobile'>
                                                                                {
                                                                                    allMakeData.length > 0 ? (
                                                                                        <BuildTab4 project_id={params.id} project_step="prescription" currentpagename="prescription" allmodels={allmodels} remortFittingFormData={remortFittingFormData} allMakeData={allMakeData} SinglePrescription={SinglePrescription} prescriptioncalc={prescription} setOptmalValues={setOptmalValues} setoptimaldataCall={updateoptimaldata} />
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }

                                                                            </div>
                                                                            <div className='design_show_mobile'>
                                                                                {
                                                                                    allMakeData.length > 0 ? (
                                                                                        <PrescTab2 status={status} project_id={params.id} project_step={`${prescriptionid === null || prescriptionid === undefined
                                                                                            ? "prescription" : "prescription"}`} allmodels={allmodels} remotefittingdataofdata={remortFittingFormData} prescriptioncalc={prescription} SinglePrescription={SinglePrescription} allMakeData={allMakeData} setoptimaldataCall={updateoptimaldata} studioshow={studioshow} />
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    </>) : (<> </>)
            }
        </>
    );
}

export default Prescription;